<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Fee Structure</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Admission</a></span>
                                        </div>
                                        <span>Fee Structure</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <section class="bd-faq-area-2 theme-bg-6 pt-120 pb-70">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="bd-section-title-wrapper text-center mb-35 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h2 class="bd-section-title mb-0">Fee Structure</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bd-routine-table mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Class</th>
                                        <th scope="col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Nursery</td>
                                        <td>2614</td>
                                    </tr>
                                    <tr>
                                        <td>L.K.G</td>
                                        <td>2614</td>
                                    </tr>
                                    <tr>
                                        <td>U.K.G</td>
                                        <td>2614</td>
                                    </tr>
                                    <tr>
                                        <td>Class 1</td>
                                        <td>3432</td>
                                    </tr>
                                    <tr>
                                        <td>Class 2</td>
                                        <td>3432</td>
                                    </tr>
                                    <tr>
                                        <td>Class 3</td>
                                        <td>3432</td>
                                    </tr>
                                    <tr>
                                        <td>Class 4</td>
                                        <td>3432</td>
                                    </tr>
                                    <tr>
                                        <td>Class 5</td>
                                        <td>3432</td>
                                    </tr>
                                    <tr>
                                        <td>Class 6</td>
                                        <td>4356</td>
                                    </tr>
                                    <tr>
                                        <td>Class 7</td>
                                        <td>4356</td>
                                    </tr>
                                    <tr>
                                        <td>Class 8</td>
                                        <td>4356</td>
                                    </tr>
                                    <tr>
                                        <td>Class 9</td>
                                        <td>6600</td>
                                    </tr>
                                    <tr>
                                        <td>Class 10</td>
                                        <td>7260</td>
                                    </tr>
                                    <tr>
                                        <td>Class 11 (Commmerce)</td>
                                        <td>9240</td>
                                    </tr>
                                    <tr>
                                        <td>Class 12 (Commmerce)</td>
                                        <td>9900</td>
                                    </tr>
                                    <tr>
                                        <td>Class 11 (Science)</td>
                                        <td>13000</td>
                                    </tr>
                                    <tr>
                                        <td>Class 12 (Science)</td>
                                        <td>15000</td>
                                    </tr>
                                    <tr>
                                        <td>Class 11 (Arts)</td>
                                        <td>10000</td>
                                    </tr>
                                    <tr>
                                        <td>Class 12 (Arts)</td>
                                        <td>12000</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
export default {
    name: "FeesView",
};
</script>
